import { render, staticRenderFns } from "./ConfirmToDeleteOrder.vue?vue&type=template&id=8a212856&scoped=true"
import script from "./ConfirmToDeleteOrder.vue?vue&type=script&lang=js"
export * from "./ConfirmToDeleteOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a212856",
  null
  
)

export default component.exports